import { API_URL, requestData } from "./utils";
export default class FileStoreModule {
  getFileStoreList(query, link: string = "/query/filestore") {
    return requestData("GET", link, query);
  }

  async getJwtToken() {
    return await fetch(`${API_URL}/token`, {
      method: "get",
      mode: "cors",
      credentials: "include",
    }).then((res) => res.text());
  }

  async downloadReport(file_store_item_public_url) {
    const jwt =  await this.getJwtToken();
    try {
      const a = document.createElement("a");
      a.href = `${file_store_item_public_url}?token=${jwt}`;
      a.setAttribute("type", "hidden");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error during download:", error);
    }
  }

  //item id gets deleted but still appears in the GET API
  deleteGeneratedReport(item_id) {
    return requestData("DELETE", `/delete/filestore/${item_id}`);
  }
}
